"use client";

import { FC, useEffect, useState, useRef } from "react";
import { useParams, useSearchParams } from "next/navigation";

import { cn } from "utils";
import { useSnapshot } from "valtio";
import { deviceDetector } from "@ospweb/sdk-ui";
import { MenuFooter, MenuFooterMobile } from "./MenuFooter";
import { MenuGuide, MenuGuideMobile } from "./MenuGuide";
import { HomeStore } from "@/src/store";
import { useIsPc } from "@/src/hooks";

interface MenuContentProps {
  isShowLogo?: boolean;
  onCancel?: () => void;
  className?: string;
  locale?: string;
}

const MenuContentInner: FC<MenuContentProps> = ({
  onCancel,
  className,
  locale,
}) => {
  const params = useParams();
  const searchParams = useSearchParams();
  const tpl = searchParams.get("tpl");
  const { isOpen } = useSnapshot(HomeStore);
  const agentId = params?.agentId as string;
  const currentPath = `/${agentId || ""}${tpl ? `?tpl=${tpl}` : ""}`;
  const [selectedPath, setSelectedPath] = useState<string>(currentPath);
  const [isPc] = useIsPc();

  // 创建 MenuFooter 的 ref，用于动态高度计算
  const menuFooterRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const tpl = searchParams.get("tpl");
    setSelectedPath(`/${params?.agentId || ""}${tpl ? `?tpl=${tpl}` : ""}`);
  }, [params?.agentId, searchParams]);

  return (
    <div
      className={cn(
        "flex flex-col items-stretch flex-1 h-[calc(100vh-8px)]",
        {
          "md:w-[292px]": isOpen,
        },
        className,
      )}
    >
      {/* MenuGuide 区域 - 使用 flex-1 占据剩余空间，内部滚动 */}
      <div className={cn("flex-1 min-h-0")}>
        {!isPc || deviceDetector.isMobile() ? (
          <MenuGuideMobile locale={locale} />
        ) : (
          <MenuGuide
            onCancel={onCancel}
            selectedPath={selectedPath}
            onPathSelected={setSelectedPath}
            menuFooterRef={menuFooterRef}
            locale={locale}
          />
        )}
      </div>

      {/* MenuFooter 区域 - 固定在底部 */}
      <div
        ref={menuFooterRef}
        className="flex-shrink-0"
        data-tracking-scope="footer"
      >
        {deviceDetector.isMobile() ? (
          <MenuFooterMobile locale={locale} />
        ) : (
          <MenuFooter
            onCancel={onCancel}
            onLinkClick={() => {
              setSelectedPath("");
            }}
            locale={locale}
          />
        )}
      </div>
    </div>
  );
};

export const MenuContent: FC<MenuContentProps> = (props) => {
  return <MenuContentInner {...props} />;
};
